
import {
  computed,
  defineComponent,
  useFetch,
  useMeta,
} from '@nuxtjs/composition-api';
import PageBlocks from '~/components/shared/PageBlocks.vue';
import useFetchProduct from '~/composables/useFetchProduct';
import ProductPreviewSection from '~/domains/product/components/ProductPreviewSection';
import useAlternateLinks from '~/composables/useAlternateLinks';

export default defineComponent({
  components: {
    ProductPreviewSection,
    PageBlocks,
  },
  head: {},
  setup() {
    const {
      product,
      isLoadingProduct,
      allDocuments,
      isLoadingDocuments,
      productDocuments,
      productUserGuides,
      fetchProduct,
      fetchProductDocuments,
      filterDocuments,
    } = useFetchProduct();

    useFetch(async () => {
      await fetchProduct();
      await fetchProductDocuments();
      filterDocuments();
    });
    const { alternateLinks } = useAlternateLinks();

    const breadcrumbs = computed({
      get() {
        if (!product.value) return null;
        return [
          ...product.value.category_branch.map((item, i) => ({
            title: item.name,
            link: `${i === 0 ? '/category' : ''}/${item.slug}`,
          })),
          {
            title: product.value.name,
          },
        ];
      },
      set() {},
    });

    const checkData = (sectionName) => {
      return product?.value?.content.find((block) => {
        return block.type === sectionName;
      });
    };

    const getProductAboutSectionData = computed({
      get: () => checkData('rich_about'),
      set: () => {},
    });

    const getProductVideoSectionData = computed({
      get: () => checkData('rich_video'),
      set: () => {},
    });

    const getProductBenefitsSectionData = computed({
      get: () => checkData('rich_benefits'),
      set: () => {},
    });

    const getProductBoxSectionData = computed({
      get: () => checkData('rich_box_contents'),
      set: () => {},
    });

    const getProductAsbisUiSections = computed({
      get: () =>
        product?.value?.content.filter((block) => {
          return (
            block.content_type &&
            block.content_type === 'asbis-ui' &&
            !block.content
          );
        }),
      set: () => {},
    });

    useMeta(() => ({
      title: product.value?.seo?.page_title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: product.value?.seo?.description,
        },
        {
          property: 'og:title',
          content: product.value?.seo?.page_title,
        },
      ],
      link: alternateLinks.value,
    }));

    return {
      getProductBoxSectionData,
      getProductBenefitsSectionData,
      getProductAboutSectionData,
      getProductVideoSectionData,
      getProductAsbisUiSections,
      isLoadingDocuments,
      isLoadingProduct,
      product,
      allDocuments,
      breadcrumbs,
      productDocuments,
      productUserGuides,
    };
  },
});
